import React, { Component, ComponentType } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { Search } from '../../../components/Filters';
import { ParamChanges, updateParams } from '../../../helpers/urlParams';

import { History, Location } from 'history';
import RefreshFilterButton from '../../../components/Filters/RefreshFilterButton';
import { FilterComponentWrapper, FilterRowWrapper, FiltersContainer, FiltersWrapper, RightWrapper, Wrapper } from '../../../components/Filters/elements';

export interface StateFilterProps extends WithTranslation {
    queryParams: URLSearchParams;
    onChange: (changes: { [key: string]: string[] }) => void;
}

const updateFilterParams = (queryParams: URLSearchParams, changes: ParamChanges) => {
    // remove paging when filter changes
    const nonPagingChanges = { ...changes, starting_after: undefined };
    return updateParams(queryParams, nonPagingChanges);
};

interface FilterConfig {
    component: ComponentType<Pick<StateFilterProps, 'queryParams' | 'onChange'>>;
    keys: string[];
}

const filterConfigs: { [name: string]: FilterConfig } = {};
type FilterKey = keyof typeof filterConfigs;

interface FiltersProps extends WithTranslation {
    location: Location;
    history: History;
    refresh: () => void;
}

interface FiltersState {
    pending: FilterKey | undefined;
}

class Filters extends Component<FiltersProps, FiltersState> {
    constructor(props: FiltersProps, context: any) {
        super(props, context);
        this.state = {
            pending: undefined,
        };
        this.setPending = this.setPending.bind(this);
    }

    setPending(pending: FilterKey | undefined) {
        this.setState({ pending });
    }

    render() {
        const { t, location, history, refresh } = this.props;
        const queryParams = new URLSearchParams(location.search.substring(1));
        const search = queryParams.get('search') || undefined;
        return (
            <Wrapper>
                <FilterRowWrapper>
                    <FiltersWrapper>
                        <FilterComponentWrapper>
                            <RefreshFilterButton onClick={refresh} title={t('customers.filter.refresh')} />
                        </FilterComponentWrapper>
                    </FiltersWrapper>
                    <RightWrapper>
                        <Search
                            name="search"
                            placeholder={t('customers.filter.search_placeholder')}
                            defaultValue={search || ''}
                            onChange={value => {
                                const nextParams = updateFilterParams(queryParams, { search: value });
                                history.push(`${location.pathname}?${nextParams.toString()}`);
                            }}
                            onBlur={() => {
                            }}
                        />
                    </RightWrapper>
                </FilterRowWrapper>
                <FiltersContainer />
            </Wrapper>
        );
    }
}

export default withTranslation()<React.ComponentType<FiltersProps>>(Filters);
